import React, {Fragment} from 'react';
import MediaViewer from '../../MediaViewer';
import ImageRotation from '../../ImageRotation';
import Icon from '../../Icon';
import {apiCropImage} from '../../../../config';
import Modal from "../../Modal";


class ThumbTimeline extends React.Component {
    static defaultProps = {
        title: "",
        slug: '',
        count: {
            view: 0,
            like: 0,
        },
        filename: {
            url: ""
        },
        owner: {
            _id: 0,
            slug: '',
            username: '',
            avatar: "",
            gender: ""
        },
        currentUser: {
            _id: 1,
        },
        authorName: "",
        videoCoverUrl : ""
    };

    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            imageLoading: true,
        };

        this.handleImageLoaded = this.handleImageLoaded.bind(this);
    }

    handleImageLoaded() {
        this.setState({imageLoading: false});
    }

    render() {
        let mediaType = this.props.kind;
        // let isVideo = mediaType === 'video' ? 'thumb-video' : '';
        let loadingClass = mediaType === 'video' ? 'loading thumb-video' : 'loading';
        let thumbnailWidth = mediaType === 'video' ? 222 : 222;
        let thumbnailHeight = mediaType === 'video' ? 166 : 222;

        return (
            <div className={"thumb-timeline"}>
                <div
                    className={`thumb-wrapper ${this.state.imageLoading ? loadingClass : 'loaded'}`}
                    style={{backgroundImage: `url(${!this.state.imageLoading && (this.props.previewUrl)})`}}
                    onClick={() => !this.state.imageLoading && this.setState({toggle: true})}>
                    {mediaType === "video" ? (

                        <Fragment>
                            <ImageRotation
                                srcs={Array.isArray(this.props.previewUrl) && this.props.previewUrl.map(src => apiCropImage({
                                    url: src,
                                    width: thumbnailWidth,
                                    height: thumbnailHeight
                                }))}
                                videoCoverUrl={this.props.videoCoverUrl ? `${this.props.videoCoverUrl}?width=${thumbnailWidth}&height=${thumbnailHeight}&quality=80` : ""}
                                onLoad={() => this.handleImageLoaded()}
                                onError={() => this.setState({imageLoading: true})}
                                interval={600}
                                alt={this.props.title}
                            />
                            <div className="btn-play">
                                <Icon type="play"/>
                            </div>
                        </Fragment>
                    ) : (
                        <img
                            src={apiCropImage({
                                url: this.props.previewUrl,
                                width: thumbnailWidth,
                                height: thumbnailHeight
                            })}
                            onLoad={() => this.handleImageLoaded()}
                            onError={() => this.setState({imageLoading: true})}
                            alt={this.props.title}
                        />
                    )}
                </div>
                <Modal toggle={this.state.toggle} handleClose={() => this.setState({toggle: false})}>
                    <MediaViewer mediaId={this.props._id} mediaSlug={this.props.slug} handleClose={() => this.setState({toggle: false})}/>
                </Modal>
            </div>
        )
    }
}

export default ThumbTimeline;
